import React from "react";
import { AppRouteModel } from "../models";
import { APP_ROUTES } from "./route.constant";
import { PageManagement, AgentListing, BlogListing, DocumentationList, ResourceManagement, QuotationList } from "../app/containers";
import { PostIcon, ResourceIcon, DocumentationIcon, AgentIcon, PageManagementIcon, QuotationIcon } from "../app/icons";
import { APP_MODULES } from "./app.constant";

export const APP_CONFIG_ROUTES: AppRouteModel[] = [
  {
    sidebarTitle: "News & Trends",
    appbarTitle: "News & Trends",
    path: APP_ROUTES.BLOG.BASE,
    withSubPaths: [APP_ROUTES.BLOG.BLOG_DETAIL, APP_ROUTES.PROMOTION.BASE, APP_ROUTES.PROMOTION.PROMOTION_DETAIL],
    icons: {
      active: <PostIcon size={[28, 28]} color="#fff" />,
      inactive: <PostIcon size={[28, 28]} color="#6C778D" />,
    },
    renderComponent: () => {
      return <BlogListing />;
    },
    module: APP_MODULES.POST,
  },

  {
    sidebarTitle: "Videos",
    appbarTitle: "Videos",
    path: APP_ROUTES.RESOURCE.VIDEO.VIDEOHOMEPAGE.BASE,
    withSubPaths: [
      APP_ROUTES.RESOURCE.VIDEO.VIDEOHOMEPAGE.DETAIL,
      APP_ROUTES.RESOURCE.VIDEO.VIDEORESOURCE.BASE,
      APP_ROUTES.RESOURCE.VIDEO.VIDEORESOURCE.DETAIL,
    ],
    icons: {
      active: <ResourceIcon size={[28, 28]} color="#fff" />,
      inactive: <ResourceIcon size={[28, 28]} color="#6C778D" />,
    },
    renderComponent: () => {
      return <ResourceManagement />;
    },
    module: APP_MODULES.RESOURCE,
  },
  {
    sidebarTitle: "Partners & Agents",
    appbarTitle: "Partners & Agents",
    path: APP_ROUTES.AGENT.BASE,
    withSubPaths: [APP_ROUTES.AGENT.AGENT_DETAIL],
    icons: {
      active: <AgentIcon size={[28, 28]} color="#fff" />,
      inactive: <AgentIcon size={[28, 28]} color="#6C778D" />,
    },
    renderComponent: () => {
      return <AgentListing />;
    },
    module: APP_MODULES.AGENT,
  },

  {
    sidebarTitle: "Documentation",
    appbarTitle: "Documentation",
    path: APP_ROUTES.DOCUMENT.BASE,
    withSubPaths: [APP_ROUTES.DOCUMENT.DOCUMENT_DETAIL],
    icons: {
      active: <DocumentationIcon size={[28, 28]} color="#fff" />,
      inactive: <DocumentationIcon size={[28, 28]} color="#6C778D" />,
    },
    renderComponent: () => {
      return <DocumentationList />;
    },
    module: APP_MODULES.DOCUMENT,
  },

  {
    sidebarTitle: "Page management",
    appbarTitle: "Page management",
    path: APP_ROUTES.PAGEMANAGEMENT.BANNER.BASE,
    withSubPaths: [
      APP_ROUTES.PAGEMANAGEMENT.BANNER.DETAIL,
      APP_ROUTES.PAGEMANAGEMENT.SOLUTION.BASE,
      APP_ROUTES.PAGEMANAGEMENT.SOLUTION.DETAIL,
      APP_ROUTES.PAGEMANAGEMENT.FOCUSED_MARKET.BASE, 
      APP_ROUTES.PAGEMANAGEMENT.FOCUSED_MARKET.DETAIL, 
      APP_ROUTES.PAGEMANAGEMENT.NETWORK.BASE,
      APP_ROUTES.PAGEMANAGEMENT.NETWORK.DETAIL,
      APP_ROUTES.PAGEMANAGEMENT.CAREER.BASE,
      APP_ROUTES.PAGEMANAGEMENT.CAREER.DETAIL,
    ],
    icons: {
      active: <PageManagementIcon size={[28, 28]} color="#fff" />,
      inactive: <PageManagementIcon size={[28, 28]} color="#6C778D" />,
    },
    renderComponent: () => {
      return <PageManagement />;
    },
    module: APP_MODULES.PAGE,
  },
  
  {
    sidebarTitle: "Quotation",
    appbarTitle: "Quotation",
    path: APP_ROUTES.QUOTATION.BASE,
    withSubPaths: [],
    icons: {
      active: <QuotationIcon size={[24, 26]} color="#fff" />,
      inactive: <QuotationIcon size={[24, 28]} color="#6C778D" />,
    },
    renderComponent: () => {
      return <QuotationList />;
    },
    module: APP_MODULES.QUOTATION,
  }
];
